export const REFINEMENTS_ACTIONS = {

	GET_CROP_METADATA_FOR_FRAME_AJAX: "GET_CROP_METADATA_FOR_FRAME_AJAX",
	GET_CROP_METADATA_FOR_FRAME_SUCCESS: "GET_CROP_METADATA_FOR_FRAME_SUCCESS",
	GET_CROP_METADATA_FOR_FRAME_ERROR: "GET_CROP_METADATA_FOR_FRAME_ERROR",
	CLEAR_CROP_METADATA_DICTIONARY: "CLEAR_CROP_METADATA_DICTIONARY",

	GET_PREVIEW_CONTENT_AJAX: "GET_PREVIEW_CONTENT_AJAX",
	GET_PREVIEW_CONTENT_SUCCESS: "GET_PREVIEW_CONTENT_SUCCESS",
	GET_PREVIEW_CONTENT_ERROR: "GET_PREVIEW_CONTENT_ERROR",

	FETCH_VERSION_WITH_REFINEMENTS_AJAX: "FETCH_VERSION_WITH_REFINEMENTS_AJAX",
	FETCH_VERSION_WITH_REFINEMENTS_SUCCESS: "FETCH_VERSION_WITH_REFINEMENTS_SUCCESS",
	FETCH_VERSION_WITH_REFINEMENTS_ERROR: "FETCH_VERSION_WITH_REFINEMENTS_ERROR",

	UPDATE_VERSION_WITH_REFINEMENTS_AJAX: "UPDATE_VERSION_VARIABLES_AJAX",
	UPDATE_VERSION_WITH_REFINEMENTS_SUCCESS: "UPDATE_VERSION_VARIABLES_SUCCESS",
	UPDATE_VERSION_WITH_REFINEMENTS_ERROR: "UPDATE_VERSION_VARIABLES_ERROR",

	SET_ACTIVE_VARIABLE: "SET_ACTIVE_VARIABLE",
	CLEAR_ACTIVE_VARIABLE: "CLEAR_ACTIVE_VARIABLE",

	GET_ASSET_REFINEMENTS_AJAX: "GET_ASSET_REFINEMENTS_AJAX",
	GET_ASSET_REFINEMENTS_SUCCESS: "GET_ASSET_REFINEMENTS_SUCCESS",
	GET_ASSET_REFINEMENTS_ERROR: "GET_ASSET_REFINEMENTS_ERROR",


	SET_VARIATION_REFINEMENT: "SET_VARIATION_REFINEMENT",

	CLEAR_REFINEMENTS: "CLEAR_REFINEMENTS",
};
